// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mSxa","comment":"styles_comment__6u3Ey"};